export default function Testimonial() {
  return (
    <section
      data-testid="testimonial-section"
      className="py-24 md:py-36 border-t border-black/10"
    >
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <span className="overline">05 — Word of mouth</span>
        <blockquote className="mt-8 font-serif-display text-3xl sm:text-4xl md:text-5xl leading-[1.15] tracking-[-0.01em]">
          <span className="italic-display text-[#c9a878] text-4xl md:text-6xl align-top">
            “
          </span>
          This was the best experience I have had with real estate photography
          in <span className="italic-display">13 years.</span> Easy to schedule,
          a fair price, and refreshingly fast.
          <span className="italic-display text-[#c9a878] text-4xl md:text-6xl align-bottom">
            ”
          </span>
        </blockquote>
        <div className="mt-10 flex items-center justify-center gap-4">
          <span className="hairline w-12" />
          <div className="overline text-[#000000]">
            Lisa Hamel · Williams Realty Partners
          </div>
          <span className="hairline w-12" />
        </div>
      </div>
    </section>
  );
}
